import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, Injector } from '@angular/core';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedLayoutModule } from './components/shared/layout/layout.module';
import { ConfigService } from './services/config.service';
import { LoginComponent } from './components/login/login.component';
import { SharedModule } from './components/shared/shared.module';
import { BreadcrumbInitializedGuard } from './services/breadcrumb.guard';
import { BreadcrumbService } from './services/breadcrumb.service';
import { AppToastService } from './services/app-toast.service';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { AuthService } from './services/auth.service';
import { TokenInterceptor } from './services/token.interceptor';
import { TokenStorageService } from './services/token-storage.service';
import { AppTitleService } from './services/app-title.service';
import { AuthGuard } from './services/auth-guard.service';
import { NgProgressbar, provideNgProgressOptions } from 'ngx-progressbar';
import { NgProgressHttp, progressInterceptor } from 'ngx-progressbar/http';
// import { provideNgProgressRouter } from 'ngx-progressbar/router';
import {TreeSelectModule} from 'primeng/treeselect';
import {FileUploadModule} from 'primeng/fileupload';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { ApiInterceptor } from './services/api.interceptor';
import {
  ApplicationInitializerFactory,
  HttpLoaderFactory,
} from './utils/translations.config';
import { DmTaiLieuService } from './services/dmtailieu.service';

const appInitializerFn = (appConfig: ConfigService) => {
  return () => {
      return appConfig.loadAppConfig();
  }
};

@NgModule({
  declarations: [AppComponent, LoginComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedLayoutModule,
    SharedModule,
    ToastModule,
    ConfirmDialogModule,
    TreeSelectModule,
    FileUploadModule,
    // NgProgressModule.withConfig({
    //   spinnerPosition: 'left',
    //   color: '#f71cff',
    // }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    // NgProgressHttpModule,
    // NgProgressRouterModule,
    NgProgressbar,
    NgProgressHttp
  ],
  providers: [
    // provideNgProgressOptions({
    //   spinner: false,
    //   trickleSpeed: 200,
    //   min: 20,
    //   flat: true
    // }),
    // provideNgProgressHttp({}),
    // provideNgProgressRouter({}),
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [ConfigService],
    },
    BreadcrumbInitializedGuard,
    BreadcrumbService,
    MessageService,
    AppToastService,
    ConfirmationService,
    TokenStorageService,
    AppTitleService,
    DmTaiLieuService,
    AuthService,
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: ApplicationInitializerFactory,
      deps: [TranslateService, Injector],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
